export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">联系我们</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              亲亲漫画网欢迎漫友们的反馈与建议。无论是漫画资源推荐、阅读体验优化建议，还是合作洽谈，都可以通过以下方式联系我们。你的每一条留言都会帮助我们打造更好的<strong className="text-foreground-900">下拉式漫画阅读</strong>平台。
            </p>
            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-600">contact@qinqinmanga.com</span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0">
                  <i className="ri-message-3-line text-accent-500 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-600">漫画投稿与合作请发送邮件，运营团队将在24小时内回复</span>
              </div>
            </div>
            <a
              href="mailto:contact@qinqinmanga.com"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer text-sm"
            >
              <i className="ri-send-plane-line text-lg"></i>
              发送邮件
            </a>
          </div>
          <div className="flex-1 w-full">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20customer%20support%20concept%20with%20manga%20books%20and%20a%20laptop%20on%20a%20cozy%20desk%2C%20soft%20indoor%20lighting%2C%20friendly%20atmosphere%2C%20orange%20and%20cream%20color%20palette%2C%20professional%20editorial%20photography%2C%20clean%20aesthetic&width=1200&height=900&seq=contact-manga-support&orientation=landscape"
                alt="亲亲漫画网联系我们"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}